"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MrsMudSpotter_exports = {};
__export(MrsMudSpotter_exports, {
  MrsMudSpotter: () => MrsMudSpotter
});
module.exports = __toCommonJS(MrsMudSpotter_exports);
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
const MrsMudSpotter = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("MrsMudSpotter"),
  title: "Mud Spotter",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("MrsMudSpotter"),
      title: "Sources",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("MrsMudSpotter"),
        attribution: []
      }),
      defaultAttribute: "sourceType",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey",
          attributes: [
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "surveyType",
              label: "Survey Type",
              enum: import_inventory_enums.MrsMudSpotterSurveyTypeEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Site",
          attributes: [
            (0, import_topo_map.stringAttr)({
              attributeId: "riverName",
              label: "River",
              buckets: "auto"
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "reachName",
              label: "Reach",
              buckets: "auto"
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "siteName",
              label: "Site",
              buckets: "auto"
            }),
            (0, import_topo_map.attachmentAttr)("photographs", "Photographs")
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Source Type",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "sourceType",
              label: "Source Type",
              enum: import_inventory_enums.MrsMudSpotterSourceTypeEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Disturbed Bank Face Sources",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "disturbedBankFaceSourceType",
              label: "Source Sub-Type",
              enum: import_inventory_enums.MrsMudSpotterDisturbedBankFaceSourceTypeEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Overland Flow Sources",
          attributes: [
            (0, import_topo_map.booleanAttr)({
              attributeId: "overlandFlowSourceVisible",
              label: "Source Visible?",
              buckets: "auto"
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "overlandFlowSourceType",
              label: "Source Sub-Type",
              enum: import_inventory_enums.MrsMudSpotterOverlandFlowSourceTypeEnum
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "overlandFlowDistance",
              label: "Distance to Source",
              unit: "m",
              buckets: "auto"
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Source Size",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "sourceSize",
              label: "Source Size",
              enum: import_inventory_enums.MrsMudSpotterSourceSizeEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Water Flow from Source",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "flow",
              label: "Water Flow",
              enum: import_inventory_enums.MrsMudSpotterFlowEnum
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "sediment",
              label: "Mud in Flowing Water",
              enum: import_inventory_enums.MrsMudSpotterSedimentEnum
            })
          ]
        })
      ]
    }),
    (0, import_topo_map.lineLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("MrsMudSpotterOverlandFlow"),
      title: "Overland Flow",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("MrsMudSpotterOverlandFlow"),
        attribution: []
      }),
      defaultAttribute: "overlandFlowSourceType",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Survey",
          attributes: [
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            }),
            (0, import_topo_map.booleanAttr)({
              attributeId: "training",
              label: "Training?",
              buckets: "auto"
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Site",
          attributes: [
            (0, import_topo_map.stringAttr)({
              attributeId: "riverName",
              label: "River",
              buckets: "auto"
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "reachName",
              label: "Reach",
              buckets: "auto"
            }),
            (0, import_topo_map.stringAttr)({
              attributeId: "siteName",
              label: "Site",
              buckets: "auto"
            }),
            (0, import_topo_map.attachmentAttr)("photographs", "Photographs")
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Overland Flow",
          attributes: [
            (0, import_topo_map.booleanAttr)({
              attributeId: "overlandFlowSourceVisible",
              label: "Source Visible?",
              buckets: "auto"
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "overlandFlowSourceType",
              label: "Source Sub-Type",
              enum: import_inventory_enums.MrsMudSpotterOverlandFlowSourceTypeEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Source Size",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "sourceSize",
              label: "Source Size",
              enum: import_inventory_enums.MrsMudSpotterSourceSizeEnum
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Water Flow from Source",
          attributes: [
            (0, import_topo_map.enumAttr)({
              attributeId: "flow",
              label: "Water Flow",
              enum: import_inventory_enums.MrsMudSpotterFlowEnum
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "sediment",
              label: "Mud in Flowing Water",
              enum: import_inventory_enums.MrsMudSpotterSedimentEnum
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MrsMudSpotter
});
//# sourceMappingURL=MrsMudSpotter.js.map
